import Vue from "vue";
import App from "./App.vue";
import Fragment from "vue-fragment";
import vuetify from "./plugins/vuetify";

Vue.config.productionTip = false;

// Extra
Vue.use(Fragment.Plugin);

new Vue({
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
